<template>
  <div>
    <div class="accodion_box accodion_abc">
      <div class="accodion_box_tit">
        <a href="#target_abc" data-toggle="collapse" aria-expanded="true">
          <div class="panel-title">
            <span class="text-uppercase accordion_header-text"
              >ABC 픽업 방법</span
            >
            <span class="pull-right icon-arr"></span></div
        ></a>
      </div>
      <div
        id="target_abc"
        class="accodion_box_cont0 collapse in"
        aria-expanded="true"
      >
        <div class="accodion_box_cont">
          <div class="abc_form">
            <div class="form_group_a with_side">
              <div class="payment-item-a">
                <div class="payment-title">
                  <p class="payment-item-title">수령할 ABC 선택</p>
                </div>

                <div class="payment-content">
                  <div class="form-item-a">
                    <div class="form-col-c">
                      <span class="form_select-default">
                        <select class="form_select" v-model="matchedABC">
                          <option :value="matchedABC" selected="selected">
                            {{ matchedABC.name }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>

                  <p class="ads-sm">주소 : {{ matchedABC.address }}</p>
                </div>
              </div>

              <div class="form_group_a with_side">
                <div class="payment-item-a">
                  <div class="payment-title">
                    <p class="payment-item-title">제품 픽업하실 분 전화번호</p>
                  </div>

                  <div class="payment-content tel">
                    <div class="form-item-a">
                      <div class="form-col-c">
                        <span class="form_select_default">
                          <select class="form_select">
                            <option selected="selected" value="010">010</option>
                          </select>
                        </span>
                      </div>
                      <div class="form-col-c">
                        <input
                          type="tel"
                          class="form_input"
                          placeholder="`-` 없이 입력"
                          minlength="7"
                          maxlength="8"
                          v-bind:value="phoneNumberWithoutAreaCode"
                          @change="storeAboPhone"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="abc_cont_area">
                <div class="abc_cont">
                  <span class="sstit">픽업주문 안내</span>
                  <ul class="list-type5">
                    <li>
                      주문 후 수령하지 않은 주문에 대해서는 익월 20일에 자동
                      반품/환불 및 실적 차감이 진행됩니다.
                    </li>
                    <li class="color-red">
                      픽업주문은 당일에 한해(미인수건) 온라인에서 주문 취소가
                      가능합니다.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { log } from "@/utils/common";

export default {
  name: "PickUp",
  data() {
    return {
      abcList: [
        {
          id: "bundang",
          address:
            "경기도 성남시 분당구 구미동 159번지 베어캐슬 1, 2층 암웨이 브랜드 체험센터",
          name: "분당",
        },
        {
          id: "gangnam",
          address: "서울특별시 서초구 반포동 1141 1, 2층 암웨이 비즈니스 센터",
          name: "강남",
        },
        {
          id: "gangseo",
          address:
            "서울특별시 강서구 등촌동 73-1번지 2층(금부빌딩) 암웨이 비즈니스 센터",
          name: "강서",
        },
        {
          id: "songdo",
          address:
            "인천광역시 남동구 서창동 688 코아프라자 2층 암웨이 비즈니스 센터",
          name: "송도",
        },
        {
          id: "taejon",
          address:
            "대전광역시 유성구 하기동 519 롯데마트 노은점 2층 암웨이 비즈니스 센터",
          name: "대전",
        },
        {
          id: "cheonan",
          address:
            "충청남도 천안시 동남구 삼룡동 381-7 선문대학교 천안캠퍼스 본관 1층 한국암웨이 천안아산 센터",
          name: "천안",
        },
        {
          id: "cheongju",
          address:
            "충청북도 청주시 흥덕구 송절동 112, 113번지 암웨이 비즈니스 센터",
          name: "청주",
        },
        {
          id: "haeundae",
          address:
            "부산광역시 해운대 구좌동 1459-6번지 2층 암웨이 비즈니스 센터",
          name: "해운대",
        },
        {
          id: "busan",
          address: "부산광역시 동구 초량동 1188-1번지 암웨이 비즈니스 센터",
          name: "부산",
        },
        {
          id: "daegu",
          address: "대구광역시 북구 산격동 1579 암웨이 비즈니스 센터",
          name: "대구",
        },
        {
          id: "changwon",
          address:
            "경상남도 창원시 마산 합포구 신포1가 42번지 암웨이 비즈니스 센터",
          name: "창원",
        },
        {
          id: "ulsan",
          address: "울산광역시 남구 삼산동 211-4 암웨이 비즈니스 센터",
          name: "울산",
        },
        {
          id: "gwangju",
          address: "광구광역시 서구 매월동 322-15 암웨이 비즈니스 센터",
          name: "광주",
        },
        {
          id: "jeonju",
          address:
            "전라북도 전주시 덕진구 팔복동 3가 400번지 암웨이 비즈니스 센터",
          name: "전주",
        },
        {
          id: "gangneung",
          address:
            "강원도 강릉시 교2동 133번지 CJ대한통운 빌딩 암웨이 비즈니스 센터",
          name: "강릉",
        },
        {
          id: "jeju",
          address:
            "제주특별자치도 제주시 용담2동 2635-2번지 암웨이 비즈니스 센터",
          name: "제주",
        },
        {
          id: "astation-starcity",
          address:
            "서울시 광진구 능동로 110 스타시티영존빌딩 A동 4층, A-station 스타시티",
          name: "스타시티",
        },
      ],
    };
  },
  props: {
    abcId: {
      type: String,
      required: true,
    },
    selectedDeliveryAddress: {
      type: Object,
      required: true,
    },
  },
  computed: {
    matchedABC() {
      return this.abcList.find((abc) => abc.id === this.abcId);
    },
    phoneNumberWithoutAreaCode() {
      return this.selectedDeliveryAddress.cellphone.substring(3);
    },
  },
  mounted() {
    log("Pickup Mounted", this.matchedABC);
    this.$store.commit("pickup/updateAbcId", this.matchedABC.id);
    this.$store.commit("pickup/updateAbcAddress", this.matchedABC.address);
    this.$store.commit("pickup/updateAbcName", this.matchedABC.name);
    this.$store.commit(
      "pickup/updateAboPhone",
      this.selectedDeliveryAddress.cellphone
    );
  },
  methods: {
    storeAboPhone(event) {
      this.$store.commit("pickup/updateAboPhone", `010${event.target.value}`);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/main/components/Receive/PickUp.vue